<app-common-header></app-common-header>
<div class="printTest">
  <div class="printTest-pageHeading flex justify-between items-center">
    <div class="flex gap-4 items-center pt-3 pb-5">
      <mat-icon class="cursor-pointer" [routerLink]="'/tests'"
        >keyboard_backspace</mat-icon
      >
      <span class="printTest-pageHeading-heading">Print Test</span>
    </div>
    <div
      (click)="print()"
      class="printTest-pageHeading-printBtn cursor-pointer"
      [ngClass]="{ 'printTest-pageHeading-printBtn-disabled': printDisabled }"
    >
      Print
    </div>
  </div>
  <div class="flex printTest-sections">
    <div class="printTest-leftSection flex flex-col gap-3 pr-5">
      <div class="printTest-leftSection-option">
        <span>Test Code :</span>
        <span>{{ recievedTest?.testCode }}</span>
      </div>
      <div class="printTest-leftSection-option">
        <span>Number of modules :</span>
        <span>{{ recievedTest?.testModuleDetails?.length }}</span>
      </div>
      <div class="printTest-leftSection-option">
        <span>Show All Modules :</span>
        <mat-slide-toggle
          [(ngModel)]="showAllModules"
          (change)="checkPrintSections(true)"
          class="printTest-leftSection-option-toggle"
        ></mat-slide-toggle>
      </div>
      <div *ngIf="!showAllModules">
        <div
          *ngFor="
            let printSection of printSections;
            let printSectionIndex = index
          "
        >
          <div class="flex gap-4 items-center">
            <mat-checkbox
              [(ngModel)]="printSection.isPrintAllowed"
              (change)="checkPrintSections(false, printSectionIndex)"
              class="printTest-leftSection-option-checkBox"
            ></mat-checkbox>
            <span>{{ printSection.sectionName }}</span>
          </div>
        </div>
      </div>
      <div class="flex flex-col gap-3" *ngIf="!allModulesHidden">
        <div class="printTest-leftSection-option">
          <span>Show/Hide Explanations :</span>
          <mat-slide-toggle
            [(ngModel)]="showExplanations"
            (change)="triggerCompleteTikz(1)"
            class="printTest-leftSection-option-toggle"
          ></mat-slide-toggle>
        </div>
        <div class="printTest-leftSection-option">
          <span>Show/Hide Answers :</span>
          <mat-slide-toggle
            [(ngModel)]="showAnswers"
            (change)="triggerCompleteTikz(2)"
            class="printTest-leftSection-option-toggle"
          ></mat-slide-toggle>
        </div>
        <div class="printTest-leftSection-option">
          <span>Show/Hide Question Info :</span>
          <mat-slide-toggle
            [(ngModel)]="showQuestionInfo"
            class="printTest-leftSection-option-toggle"
          ></mat-slide-toggle>
        </div>
        <div>
          <!-- <button (click)="loadTikz()">Load tikz</button> -->
        </div>
      </div>
    </div>
    <div class="printTest-rightSection p-4 flex flex-col gap-4">
      <div class="printTest-rightSection-testCode flex justify-center">
        Test code - {{ recievedTest?.testCode }}
      </div>
      <div
        *ngIf="!showAllModules && allModulesHidden"
        class="printTest-rightSection-noModulesText"
      >
        Please select atleast one module
      </div>
      <div
        *ngFor="
          let printSection of printSections;
          let printSectionIndex = index
        "
      >
        <div
          *ngIf="printSection.isPrintAllowed || showAllModules"
          class="flex flex-col gap-4"
        >
          <div class="printTest-rightSection-moduleName">
            {{ printSection.sectionName }}
          </div>
          <div
            *ngFor="
              let questionsObj of printSection.questions;
              let questionsObjIndex = index
            "
            class="flex flex-col gap-4"
          >
            <div class="printTest-rightSection-commonHeading">
              Question {{ questionsObjIndex + 1 }}
            </div>
            <div class="flex flex-col gap-4">
              <!-- ** Questions -->
              <div
                *ngFor="
                  let questionObj of questionsObj.questionDetails.question
                    .questionData;
                  let questionObjIndex = index
                "
              >
                <app-multi-data
                  [multiData]="{
                    type: questionObj.type,
                    data: questionObj.data,
                    tikzId:
                      'printQuestion-' +
                      printSectionIndex +
                      '-' +
                      questionsObjIndex +
                      '-' +
                      questionObjIndex,
                    imageKeys: questionObj.images!,
                    listOfImages: images
                  }"
                >
                </app-multi-data>
              </div>
              <!-- ** Choices (MCQ's) - Question type = 1 -->
              <div
                *ngIf="questionsObj.questionDetails.question.questionType === 1"
                class="flex flex-col gap-8"
              >
                <div
                  *ngFor="
                    let choices of questionsObj.questionDetails.choices;
                    let choiceIndex = index
                  "
                  class="flex items-center gap-2"
                >
                  <div>{{ options[choiceIndex] }})</div>
                  <div class="flex flex-col gap-4">
                    <div
                      *ngFor="
                        let choiceData of choices.optionValue;
                        let choiceDataIndex = index
                      "
                    >
                      <app-multi-data
                        class="testCreation-right-choices-optionText"
                        [multiData]="{
                          type: choiceData.type,
                          data: choiceData.data,
                          tikzId:
                            'printChoiceOption-' +
                            printSectionIndex +
                            '-' +
                            questionsObjIndex +
                            '-' +
                            choiceIndex +
                            '-' +
                            choiceDataIndex,
                          imageKeys: choiceData.images!,
                          listOfImages: images
                        }"
                      ></app-multi-data>
                    </div>
                  </div>
                </div>
              </div>
              <!-- ** Answers (MCQ's) - Question type = 1 -->
              <div
                *ngIf="
                  questionsObj.questionDetails.question.questionType === 1 &&
                  showAnswers
                "
              >
                <div
                  *ngFor="
                    let choices of questionsObj.questionDetails.choices;
                    let choicesIndex = index
                  "
                  [ngClass]="{ hidden: !choices.isAnswer }"
                >
                  <div *ngIf="choices.isAnswer" class="flex flex-col gap-4">
                    <!-- <span class="testCreation-right-correctOption-text"
                        >Correct Option:&nbsp;
                      </span> -->
                    <div class="printTest-rightSection-commonHeading">
                      Answers
                    </div>
                    <div class="flex items-center gap-2">
                      <div class="ml-1">{{ options[choicesIndex] }})</div>
                      <div class="flex flex-col gap-4">
                        <div
                          *ngFor="
                            let choiceAnswerData of choices.optionValue;
                            let choiceAnswerIndex = index
                          "
                        >
                          <app-multi-data
                            [multiData]="{
                              type: choiceAnswerData.type,
                              data: choiceAnswerData.data,
                              tikzId:
                                'printChoiceAnswer-' +
                                printSectionIndex +
                                '-' +
                                questionsObjIndex +
                                '-' +
                                choicesIndex +
                                '-' +
                                choiceAnswerIndex,
                              imageKeys: choiceAnswerData.images!,
                              listOfImages: images
                            }"
                          ></app-multi-data>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- ** Answers (Freeetext) - Question type = 2 -->
              <div
                *ngIf="
                  questionsObj.questionDetails.question.questionType === 2 &&
                  showAnswers
                "
              >
                <div class="flex gap-2">
                  <span><b>Answers : </b></span>
                  <span>
                    {{
                      questionsObj.questionDetails.answers?.posibilities &&
                      (questionsObj.questionDetails.answers?.posibilities)!
                        .length > 0
                        ? questionsObj.questionDetails.answers?.posibilities?.join(
                            ", "
                          )
                        : "N/A"
                    }}
                  </span>
                </div>
              </div>
              <!-- ** Explanations -->
              <div class="flex flex-col gap-4">
                <div *ngIf="showExplanations" class="flex flex-col gap-4">
                  <div class="printTest-rightSection-commonHeading">
                    Explanations
                  </div>
                  <div *ngIf="questionsObj.questionType === 1">
                    <div
                      *ngFor="
                        let choices of questionsObj.questionDetails.choices;
                        let choicesIndex = index
                      "
                      class="flex flex-col gap-4"
                      [ngClass]="{ hidden: !choices.explanation }"
                    >
                      <div class="printTest-rightSection-commonHeading">
                        Option {{ options[choicesIndex] }} Explanation
                      </div>
                      <div
                        *ngFor="
                          let explanation of choices.explanation;
                          let explanationsIndex = index
                        "
                        class="flex flex-col gap-4 pb-4"
                      >
                        <app-multi-data
                          [multiData]="{
                            type: explanation.type,
                            data: explanation.data,
                            tikzId:
                              'printChoiceExplanation-' +
                              printSectionIndex +
                              '-' +
                              questionsObjIndex +
                              '-' +
                              choicesIndex +
                              '-' +
                              explanationsIndex,
                            imageKeys: explanation.images!,
                            listOfImages: images
                          }"
                        >
                        </app-multi-data>
                      </div>
                    </div>
                  </div>
                  <div *ngIf="questionsObj.questionType === 2">
                    <div
                      *ngFor="
                        let explanation of questionsObj.questionDetails.answers
                          ?.explanation;
                        let explanationIndex = index
                      "
                    >
                      <app-multi-data
                        [multiData]="{
                          type: explanation.type,
                          data: explanation.data,
                          tikzId:
                            'printFreetextExplanation-' +
                            printSectionIndex +
                            '-' +
                            questionsObjIndex +
                            '-' +
                            explanationIndex,
                          imageKeys: explanation.images!,
                          listOfImages: images
                        }"
                      >
                      </app-multi-data>
                    </div>
                  </div>
                </div>
                <!-- ** Last section in questions section (for displaying answers, tags and other info)  -->
                <div
                  *ngIf="showQuestionInfo"
                  class="flex items-end justify-between"
                >
                  <!-- <div *ngIf="showAnswers">
                      <div
                        *ngFor="
                          let choices of questionsObj.questionDetails.choices;
                          let choicesIndex = index
                        "
                        [ngClass]="{ hidden: !choices.isAnswer }"
                      >
                        <div
                          *ngIf="choices.isAnswer"
                          class="flex testCreation-right-correctOption items-end"
                        >
                          <span class="testCreation-right-correctOption-text"
                            >Correct Option:&nbsp;
                          </span>
                          <span class="testCreation-right-correctOption-option">
                            {{ options[choicesIndex] }}</span
                          >
                        </div>
                      </div>
                    </div> -->
                  <div class="printTest-rightSection-tags">
                    Tags:
                    {{
                      questionsObj.questionDetails.question.tags.length > 0
                        ? questionsObj.questionDetails.question.tags.join(", ")
                        : "N/A"
                    }}
                  </div>
                  <div class="flex flex-col printTest-rightSection-subTopic">
                    <div class="printTest-rightSection-subTopic-title">
                      Sub Topic :
                    </div>
                    <div class="printTest-rightSection-subTopic-name">
                      {{ questionsObj.subTopicName }}
                    </div>
                  </div>
                  <div class="flex flex-col printTest-rightSection-difficulty">
                    <div class="printTest-rightSection-difficulty-title">
                      Difficulty
                    </div>
                    <div
                      class="printTest-rightSection-difficulty-name capitalize"
                    >
                      {{
                        difficultyLevels[questionsObj.difficultLevel - 1].name
                      }}
                    </div>
                  </div>
                  <div
                    class="printTest-rightSection-questionType printTest-rightSection-questionType-mcq"
                    [ngClass]="{
                      'printTest-rightSection-questionType-freetext':
                        questionsObj.questionDetails.question.questionType === 2
                    }"
                  >
                    {{
                      questionsObj.questionDetails.question.questionType === 1
                        ? "MCQ"
                        : "Freetext"
                    }}
                  </div>
                </div>
              </div>
            </div>
            <mat-divider></mat-divider>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<p-dialog
  [(visible)]="isDataLoading"
  [modal]="true"
  [blockScroll]="true"
  [closeOnEscape]="true"
  [closable]="true"
  [showHeader]="false"
  appendTo="body"
  contentStyleClass="loader flex justify-center"
  styleClass="loaderContainer"
>
  <!-- <mat-spinner>Please wait</mat-spinner> -->
  <p-progressSpinner strokeWidth="4"></p-progressSpinner>
</p-dialog>

<!-- <div id="watermark">Ravi's Academy</div> -->
